import { get } from '../tools/http';

export default {
    namespaced: true,

    state: () => ({
        involvedProjects: [],
        involvedProjectsSPK2: [],
        recommendedProjects: [],
        recomendedProjCount: 0,
        mainContests: [],
        mainEvents: [],
        mainInterns: [],
    }),

    mutations: {
        writeInvolvedProjects: (state, items) => (state.involvedProjects = items),
        writeInvolvedProjectsSPK2: (state, items) => (state.involvedProjectsSPK2 = items),
        writeRecommendedProjects: (state, value) => (state.recommendedProjects = value),
        writeMainItems: (state, { type, value }) => {
            switch (type) {
                case 'contests':
                    state.mainContests = value;
                    break;
                case 'events':
                    state.mainEvents = value;
                    break;
                case 'internship':
                    state.mainInterns = value;
                    break;
            }
        },
        setRecomendedProjCount: (state, data) => (state.recomendedProjCount = data),
    },

    actions: {
        loadInvolvedProjects: async (ctx) => {
            ctx.commit('writeInvolvedProjects', []);
            const path = 'api/v1/seasons/nomination/get-my-nomination?sort[0][column]=dateStart&sort[0][order]=desc';
            const res = await get('projects', path);
            ctx.commit('writeInvolvedProjects', res || []);
        },

        loadInvolvedProjectsSPK2: async (ctx) => {
            const path = 'api/v1/project/current';
            let sbStringUrl = '';
            const domainToIdMap = {
                'rsv-test-2.bizml.ru': 69327,
                'rsv-test.bizml.ru': 70923,
                'rsv-demo.bizml.ru': 214074,
                'rsv-dev.bizml.ru': 59022,
            };
            const vacancyType = domainToIdMap[window.rsvDomain] || 218740;

            ctx.commit('writeInvolvedProjectsSPK2', []);

            try {
                const res = await get('data', 'catalog/get/spk_project_type', null, true);
                res.data
                    .filter((item) => item.field_name != 'internship')
                    .forEach((item) => {
                        if (item.id !== vacancyType) {
                            sbStringUrl += `filter[type]=${item.id}&`;
                        }
                    });
            } catch (e) {
                console.log(e);
            } finally {
                const res = await get('projects2', `${path}?${sbStringUrl}`, null, true);
                ctx.commit('writeInvolvedProjectsSPK2', res || []);
                return res;
            }
        },

        loadRecommendedProjects: async (ctx, limit) => {
            ctx.commit('writeRecommendedProjects', []);

            const path = `api/v1/seasons/nomination/get-recommended-seasons?filter[registration_is_opened]=true&limit=${limit}&offset=0&sort[0][column]=dateStart&sort[0][order]=desc`;
            const res = await get('projects', path);

            if (!res) return;
            ctx.commit('setRecomendedProjCount', res.length);
            ctx.commit('writeRecommendedProjects', res);
        },

        loadMainItems: async (ctx, type) => {
            const params = { limit: 32, offset: 0, type };
            const res = await get('projects', 'api/v1/seasons', params);

            if (!res) return;

            const writeData = { type, value: res.seasons };

            ctx.commit('writeMainItems', writeData);
        },
    },

    getters: {
        getInvolvedProjects: (state) => state.involvedProjects,
        getInvolvedProjectsSPK2: (state) => state.involvedProjectsSPK2,
        recommendedProjects: (state) => state.recommendedProjects,
        getRecomendedProjCount: (state) => state.recomendedProjCount,
        mainContests: (state) => state.mainContests,
        mainEvents: (state) => state.mainEvents,
        mainInterns: (state) => state.mainInterns,
    },
};
